import * as apollo from '@/utils/apollo'
import * as general from '@/utils/general'
import * as theme from '@/utils/theme'

export const ota = {
  apollo,
  theme,
  general
}

export default defineNuxtPlugin((nuxtApp) => {
  // Provide for composables: useNuxtApp().$ota
  nuxtApp.provide('ota', ota)
  // Alias to keep existing calls working: useNuxtApp().$ota
  // Object.defineProperty(nuxtApp, '$ota', {
  //   get() {
  //     return ota
  //   }
  // })
  // Provide for Options API components: this.$ota
  // nuxtApp.vueApp.config.globalProperties.$ota = ota
  nuxtApp.vueApp.directive('click-outside', {
    beforeMount(el, binding) {
      el.clickOutsideEvent = function (event) {
        if (!(el === event.target || el.contains(event.target))) {
          const handler = binding.value || (binding.instance && binding.instance[binding.expression])
          if (typeof handler === 'function') handler(event)
        }
      }
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unmounted(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  })
})
